"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAuth = fetchAuth;

var _enviro = _interopRequireDefault(require("enviro"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var suffix = _enviro.default.getShort() === 'qa' ? 'qa' : '';

function fetchAuth() {
  return _noAuthApiClient.default.get("https://api.hubspot" + suffix + ".com/login-verify/echo/user");
}


//////////////////
// WEBPACK FOOTER
// ./js/api/public-only/PublicAuthApi.js
// module id = 962
// module chunks = 6